import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { CreateFundingRequestBody } from "@shared-kernel/application/ports/student/student-repository";

export const createFundingRequest = createAsyncThunk<string, CreateFundingRequestBody, { extra: Partial<Dependencies> }>(
  "fundingRequests/createFundingRequest",
  async (fundingRequest: CreateFundingRequestBody, { extra: { studentRepository } }) => {
    return studentRepository!.createFundingRequest(fundingRequest);
  },
);

export const resetCreateFundingRequest = createAction("fundingRequests/resetCreateFundingRequest");
